import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsWysiwygBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsWysiwygBlockEntity
